import gql from 'graphql-tag';

const GET_SECTOR_PICKING = gql`
  query getSectorPicking {
    getSectorPicking {
        payload {
          id
          sectorPicking
          status
          locationSector
          aisleLabel
          placeLabel
          positionLabel
          trayLabel
          aisleLabelAbbreviation
          placeLabelAbbreviation
          positionLabelAbbreviation
          trayLabelAbbreviation
        }  
        internalCode
    }
  }
`;

export default GET_SECTOR_PICKING;
